var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"outlined":"","color":"blue"},on:{"click":_vm.downloadEventToCalendar}},[_vm._v(" Add to Calendar ")])}
var staticRenderFns = []

export { render, staticRenderFns }